import { useEffect } from 'react';
import {
  captureReferralFromLocation,
  getAffiliateAttributionRetryDelay,
} from './referralAttribution';

const MIN_RETRY_TIMER_MS = 1000;
const MAX_RETRY_TIMER_MS = 60 * 60 * 1000;

export default function ReferralCapture() {
  useEffect(() => {
    let active = true;
    let retryTimer = null;

    const clearRetryTimer = () => {
      if (retryTimer !== null) {
        window.clearTimeout(retryTimer);
        retryTimer = null;
      }
    };

    const scheduleRetry = () => {
      clearRetryTimer();
      if (!active) return;

      const pendingDelay = getAffiliateAttributionRetryDelay();
      if (pendingDelay === null) return;

      const delay = Math.min(
        MAX_RETRY_TIMER_MS,
        Math.max(MIN_RETRY_TIMER_MS, pendingDelay),
      );
      retryTimer = window.setTimeout(() => {
        retryTimer = null;
        void runCapture();
      }, delay);
    };

    const runCapture = async () => {
      clearRetryTimer();
      try {
        await captureReferralFromLocation();
      } catch {
        // The durable pending record remains the recovery mechanism even if a
        // browser API (rather than the transport) unexpectedly throws.
      } finally {
        scheduleRetry();
      }
    };

    const handleOnline = () => {
      void runCapture();
    };

    window.addEventListener('online', handleOnline);
    void runCapture();

    return () => {
      active = false;
      window.removeEventListener('online', handleOnline);
      clearRetryTimer();
    };
  }, []);

  return null;
}
